import template from './swag-cms-extensions-form-editor-settings-field-type-header.html.twig';

const { mapPropertyErrors } = Shopware.Component.getComponentHelper();

export default {
    template,
    mixins: [
        'swag-cms-extensions-form-group-field-error',
    ],
    computed: {
        field() {
            return Shopware.Store.get('swCmsDetailCurrentCustomForm').activeItem;
        },

        form() {
            return Shopware.Store.get('swCmsDetailCurrentCustomForm').form;
        },

        ...mapPropertyErrors('field', [
            'technicalName',
            'label',
            'type',
            'width',
        ]),

        technicalName: {
            set(newTechnicalName) {
                Shopware.Store.get('swCmsDetailCurrentCustomForm').setFieldProperty(
                    this.field.id,
                    'technicalName',
                    newTechnicalName,
                );
            },

            get() {
                return this.field.technicalName;
            },
        },

        label: {
            set(newLabel) {
                Shopware.Store.get('swCmsDetailCurrentCustomForm').setFieldProperty(
                    this.field.id,
                    'label',
                    newLabel,
                );

                if (newLabel) {
                    Shopware.Store.get('error').removeApiError(
                        `swag_cms_extensions_form_group_field.${this.field.id}.label`,
                    );
                }
            },

            get() {
                return this.field.label;
            },
        },

        type: {
            set(newType) {
                Shopware.Store.get('swCmsDetailCurrentCustomForm').setFieldType(
                    this.field.id,
                    newType,
                );
            },

            get() {
                return this.field.type;
            },
        },

        width: {
            set(newWidth) {
                Shopware.Store.get('swCmsDetailCurrentCustomForm').setFieldProperty(
                    this.field.id,
                    'width',
                    newWidth,
                );
            },

            get() {
                return this.field.width;
            },
        },

        types() {
            return [
                {
                    value: 'text',
                    label: this.$tc('swag-cms-extensions.sw-cms.components.form-editor.settings-field.types.text'),
                },
                {
                    value: 'email',
                    label: this.$tc('swag-cms-extensions.sw-cms.components.form-editor.settings-field.types.email'),
                },
                {
                    value: 'number',
                    label: this.$tc('swag-cms-extensions.sw-cms.components.form-editor.settings-field.types.number'),
                },
                {
                    value: 'checkbox',
                    label: this.$tc('swag-cms-extensions.sw-cms.components.form-editor.settings-field.types.checkbox'),
                },
                {
                    value: 'select',
                    label: this.$tc('swag-cms-extensions.sw-cms.components.form-editor.settings-field.types.select'),
                },
                {
                    value: 'textarea',
                    label: this.$tc('swag-cms-extensions.sw-cms.components.form-editor.settings-field.types.textarea'),
                },
            ];
        },

        widths() {
            return [
                {
                    value: 1,
                    label: '8%',
                },
                {
                    value: 2,
                    label: '17%',
                },
                {
                    value: 3,
                    label: '25%',
                },
                {
                    value: 4,
                    label: '33%',
                },
                {
                    value: 5,
                    label: '42%',
                },
                {
                    value: 6,
                    label: '50%',
                },
                {
                    value: 7,
                    label: '58%',
                },
                {
                    value: 8,
                    label: '67%',
                },
                {
                    value: 9,
                    label: '75%',
                },
                {
                    value: 10,
                    label: '83%',
                },
                {
                    value: 11,
                    label: '92%',
                },
                {
                    value: 12,
                    label: '100%',
                },
            ];
        },
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            // if no field is persisted yet, one could have changed the other field and we can revalidate
            // otherwise, the DAL is not able to resolve that first the old field has to be renamed first
            // we therefore need to first name this field differently and the error has to stay
            if (this.fieldTechnicalNameError && this.form._isNew) {
                Shopware.Store.get('error').removeApiError(
                    `swag_cms_extensions_form_group_field.${this.field.id}.technicalName`,
                );
                this.validateDuplicateTechnicalName(this.form, this.field);
            }
        },

        onTechnicalNameChange(newValue) {
            // If technicalName includes spaces remove all of them
            if (newValue.match(/\s/)) {
                this.technicalName = newValue.replaceAll(/\s/g, '');
            }

            this.$nextTick(() => {
                this.validateDuplicateTechnicalName(this.form, this.field);
            });
        },
    },
}
